import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {SharedModule} from "@shared/shared.module";
import {ModalConfig} from "@core/model/modal-config.model";
import { ScopeUiInputComponent } from '@shared/components/ui-components/scope-ui-input/scope-ui-input.component';
import { ScopeUiDuration } from '@shared/components/ui-components/scope-ui-duration/scope-ui-duration.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ScopeUiAutocompleteComponent
} from '@shared/components/ui-components/scope-ui-autocomplete/scope-ui-autocomplete.component';
import {
  ScopeUiDropdownComponent
} from '@shared/components/ui-components/scope-ui-dropdown/scope-ui-dropdown.component';

@Component({
  selector: 'add-edit-exchange-rate-modal',
  templateUrl: './add-edit-exchange-rate-modal.component.html',
  styleUrls: ['./add-edit-exchange-rate-modal.component.scss'],
  imports: [
    SharedModule,
    ScopeUiInputComponent,
    ScopeUiDuration,
    ScopeUiAutocompleteComponent,
    ScopeUiDropdownComponent,
  ],
  standalone: true
})
export class AddEditExchangeRateModalComponent implements OnInit{
  @Input() currencies: string[]
  @Input() exchangeRate: any = {}
  @Input() loading = false
  @Output() onSubmit: EventEmitter<any>
  modalForm: FormGroup
  initialExchangeRate: number

  constructor(@Inject(MAT_DIALOG_DATA) public data: ModalConfig) {
    this.onSubmit = new EventEmitter<any>()
  }

  ngOnInit() {
    this.initialExchangeRate = this.exchangeRate.exchangeRate
    this.modalForm = new FormGroup({
      fromCurrencyControl: new FormControl(this.exchangeRate.fromCurrencyCode, [Validators.required]),
      toCurrencyControl: new FormControl(this.exchangeRate.toCurrencyCode, [Validators.required]),
      exchangeRateControl: new FormControl(this.exchangeRate.exchangeRate, [Validators.required])
    })
  }

  disableSubmit() {
    return !this.modalForm.valid || (this.initialExchangeRate && this.exchangeRate.exchangeRate === this.initialExchangeRate)
  }

  confirm() {
    this.modalForm.markAllAsTouched()
    if (this.modalForm.valid) {
      this.loading = true
      this.onSubmit.emit(this.exchangeRate)
    }
  }

  getControl = (key: string) => this.modalForm.get(key) as FormControl

  optionFunction = (option: string) => {
    return option;
  }
}


